import BannerAdStatic from './BannerAdStatic';

export default BannerAdStatic;
